<template>
    <div v-if="isMounted" id="loan-request-step-detail" class="">
        <div v-if="!isRejected && !isArchived" class="vx-row text-start">
            <!-- SOLICITUD -->
            <div v-if="steps[0] == 1" class="vx-col w-full">
                <div class="vx-row same-h">
                    <!-- ESTADO DE LA SOLICITUD -->
                    <div class="vx-col sm:w-full md:w-1/3">
                        <vx-card>
                            <h4 class="mb-4">{{ getPreapprovedTitle }}</h4>
                            <vs-chip class="chip-black" :color="project.preapproved != null ? '#BBFFAA' : '#FFF1E3'">{{ project.preapproved != null ? 'Listo' : 'Pendiente' }} &nbsp;&nbsp;</vs-chip>
                            <br><br>
                            <br>
                            <p v-html="getPreapprovedDescription" class="mb-base black text-sm"></p>
                            <vs-button @click.stop="goToPage(0)" color="#3B3A3E">Continuar</vs-button>
                        </vx-card>
                    </div>
                    <!-- PROCESO DEL SOLICITANTE -->
                    <div class="vx-col sm:w-full md:w-1/3">
                        <vx-card>
                            <h4 class="mb-4">Proceso del solicitante</h4>
                            <vs-chip class="chip-black" :color="applicantIsCompleted ? '#BBFFAA' : '#FFF1E3'">{{ applicantIsCompleted ? 'Listo' : 'Pendiente' }} &nbsp;&nbsp;</vs-chip>
                            <br><br>
                            <br>
                            <div class="flex items-center">
                                <feather-icon class="mr-2 h-4 w-4" :class="accountIsActive ? 'text-primary' : 'text-grey'" :icon="accountIsActive ? 'CheckCircleIcon' : 'ClockIcon'" />
                                <small class="black">
                                    Activar cuenta
                                </small>
                            </div>
                            <div class="flex items-center">
                                <feather-icon class="mr-2 h-4 w-4" :class="hasCDCDataCompleted ? 'text-primary' : 'text-grey'" :icon="hasCDCDataCompleted ? 'CheckCircleIcon' : 'ClockIcon'" />
                                <small class="black">
                                    Consulta crediticia
                                </small>
                            </div>
                            <div v-if="!isMoral" class="flex items-center mb-base">
                                <feather-icon class="mr-2 h-4 w-4" :class="hasPersonalIdentityVerification ? 'text-primary' : 'text-grey'" :icon="hasPersonalIdentityVerification ? 'CheckCircleIcon' : 'ClockIcon'" />
                                <small class="black">
                                    Verificación de identidad
                                </small>
                            </div>
                            <div v-if="isMoral" class="flex items-center mb-base">
                                <feather-icon class="mr-2 h-4 w-4" :class="hasSyntage ? 'text-primary' : 'text-grey'" :icon="hasSyntage ? 'CheckCircleIcon' : 'ClockIcon'" />
                                <small class="black">
                                    Conexión SAT (CIEC)
                                </small>
                            </div>
                            <div class="flex items-center">
                                <vs-button @click.stop="requestApplicantNotification('activation')" size="sm" color="#3B3A3E" class="mr-4 pl-2 pr-2">Enviar recordatorio</vs-button>
                                <p @click.stop="copyClipboard('applicant')" class="black flex">
                                    <u class="clickable-img mt-2">Copiar enlace</u>
                                    <feather-icon class="mr-2 h-5 w-5 ml-2 mt-2" icon="CopyIcon"></feather-icon>
                                </p>
                            </div>
                        </vx-card>
                    </div>
                    <!-- PROCESO DE OS -->
                    <div class="vx-col sm:w-full md:w-1/3">
                        <vx-card>
                            <h4 class="">Proceso del obligado solidario</h4>
                            <div v-if="guaranteesList.length > 0">
                                <vs-tabs v-model="activeTab" color="primary">
                                    <vs-tab v-for="(tab, index) in guaranteesList" :key="index" :label="getName(tab.guarantee_profile)">
                                        <div class="pt-2">
                                            <vs-chip class="chip-black" :color="hasGuaranteeData(0, tab) && hasGuaranteeData(1, tab) && hasGuaranteeData(2, tab) ? '#BBFFAA' : '#FFF1E3'">{{ hasGuaranteeData(0, tab) && hasGuaranteeData(1, tab) && hasGuaranteeData(2, tab) ? 'Listo' : 'Pendiente' }} &nbsp;&nbsp;</vs-chip>
                                            <br><br>
                                            <div class="flex items-center">
                                                <feather-icon class="mr-2 h-4 w-4" :class="hasGuaranteeData(0, tab) ? 'text-primary' : 'text-grey'" :icon="hasGuaranteeData(0, tab) ? 'CheckCircleIcon' : 'ClockIcon'" />
                                                <small class="black">
                                                    Comprobante de domicilio
                                                </small>
                                            </div>
                                            <div class="flex items-center">
                                                <feather-icon class="mr-2 h-4 w-4" :class="hasGuaranteeData(1, tab) ? 'text-primary' : 'text-grey'" :icon="hasGuaranteeData(1, tab) ? 'CheckCircleIcon' : 'ClockIcon'" />
                                                <small class="black">
                                                    Consulta crediticia
                                                </small>
                                            </div>
                                            <div class="flex items-center mb-base">
                                                <feather-icon class="mr-2 h-4 w-4" :class="hasGuaranteeData(2, tab) ? 'text-primary' : 'text-grey'" :icon="hasGuaranteeData(2, tab) ? 'CheckCircleIcon' : 'ClockIcon'" />
                                                <small class="black">
                                                    Verificación de identidad
                                                </small>
                                            </div>
                                            <div class="flex items-center">
                                                <vs-button size="sm" color="#3B3A3E" class="mr-4 pl-2 pr-2" @click.stop="requestNotificationToGuarantee(tab)">Enviar recordatorio</vs-button>
                                                <p @click.stop="copyClipboard('os-url', tab)" class="black flex" id="os-url">
                                                    <u class="clickable-img mt-2">Copiar enlace</u>
                                                    <feather-icon class="mr-2 h-5 w-5 ml-2 mt-2" icon="CopyIcon"></feather-icon>
                                                </p>
                                            </div>
                                        </div>
                                    </vs-tab>
                                </vs-tabs>
                            </div>
                            <div v-else>
                                <p class="mt-12 black text-sm">Aún no se han agregado obligados solidarios para esta solicitud. Contar con un obligado solidario te permite obtener mejores condiciones para tu crédito y puede responder por el pago del mismo.</p>
                            </div>
                        </vx-card>
                    </div>
                </div>
            </div>
            <!-- REVISIÓN DE SOLICITUD -->
            <div v-if="steps[1] == 1" class="vx-col w-full">
                <vx-card>
                    <h4 class="mb-4">Estamos revisando la solicitud</h4>
                    <p>
                        Enviaste la solicitud completa, estamos verificándola para poder aprobar el crédito. 
                        <br>Recibirás un correo en 1 día hábil para confirmar el estado de la solicitud. 
                    </p>
                </vx-card>
            </div>
            <!-- APROBADO -->
            <div v-if="steps[2] == 1" class="vx-col w-full">
                <div class="vx-row same-h">
                    <div class="vx-col sm:w-full md:w-1/2 mb-2">
                        <vx-card>
                            <h4 class="mb-base">¡Crédito aprobado!</h4>
                            <p class="mb-4 black text-sm">
                                Enviamos una oferta de crédito a tu cliente. 
                                El fondeo del proyecto comenzará cuando tu cliente acepte la oferta.
                            </p>
                        </vx-card>
                    </div>
                    <div class="vx-col sm:w-full md:w-1/2 mb-2">
                        <vx-card>
                            <h4 class="mb-4">¿Qué falta?</h4>
                            <p class="mb-2 black text-sm">
                                Oferta de crédito
                            </p>
                            <vs-chip class="chip-black" :color="loanAccepted ? '#BBFFAA' : '#FFF1E3'">{{ loanAccepted ? 'Aceptada' : 'Pendiente de aceptar' }}</vs-chip>
                            {{ project.finance.credit_acceptance_date }}
                            <br><br>
                            <div class="flex mt-3">
                                <vs-button @click.stop="requestApplicantNotification('loan-offer')" size="sm" color="#3B3A3E" class="mr-4 pl-2 pr-2">Enviar recordatorio</vs-button>
                                <p @click.stop="copyClipboard('loan_offer')" class="black flex">
                                    <u class="clickable-img mt-2">Copiar enlace</u>
                                    <feather-icon class="mr-2 h-5 w-5 ml-2 mt-2" icon="CopyIcon"></feather-icon>
                                </p>
                            </div>
                        </vx-card>
                    </div>
                </div>
            </div>
            <!-- FONDEO -->
            <div v-if="steps[3] == 1" class="vx-col w-full">
                <div class="vx-row same-h">
                    <div class="vx-col sm:w-full md:w-1/2 mb-2">
                        <vx-card>
                            <h4 class="mb-base">¡Crédito en fondeo!</h4>
                            <p class="mb-4 black text-sm">
                                Tu cliente aceptó la oferta y el proyecto ya se encuentra en fondeo. 
                                Estamos generando los contratos y recibirás un correo cuando estén listos para firmar. 
                            </p>
                        </vx-card>
                    </div>
                    <div class="vx-col sm:w-full md:w-1/2 mb-2">
                        <vx-card>
                            <h4 class="mb-2">¿Qué falta?</h4>
                            <div class="w-full mb-4">
                                <project-fund-progress :total="project.finance.financed_amount"
                                    :invested="project.invested" :percentage="project.percentage"
                                    :remaining_days="project.dias_restantes" :investors="project.inversionistas" />
                            </div>
                            <div class="mb-base">
                                <p class="mb-1">Contratos</p>
                                <vs-chip class="chip-black" :color="hasContracts ? '#BBFFAA' : '#FFF1E3'">{{ hasContracts ? 'Generados' : 'Pendiente de generar' }}</vs-chip>
                            </div>
                        </vx-card>
                    </div>
                </div>
            </div>
            <!-- CONTRATOS -->
            <div v-if="steps[4] == 1" class="vx-col w-full">
                <div class="vx-row same-h">
                    <div class="vx-col sm:w-full md:w-1/2 mb-2 mb-base">
                        <vx-card>
                            <h4 class="mb-base mt-4">Firma de contratos</h4>
                            <p class="mb-4 black text-sm mb-base">
                                Ya puedes firmar los contratos mientras avanza el fondeo del proyecto. 
                            </p>
                            <vs-button @click.stop="goToPage(3)" color="#3B3A3E">Firmar contratos</vs-button>
                        </vx-card>
                    </div>
                    <div class="vx-col sm:w-full md:w-1/2 mb-2 mb-base">
                        <vx-card>
                            <h4 class="mb-2">¿Qué falta?</h4>
                            <div class="w-full mb-4">
                                <project-fund-progress :total="project.finance.financed_amount"
                                    :invested="project.invested" :percentage="project.percentage"
                                    :remaining_days="project.dias_restantes" :investors="project.inversionistas" />
                            </div>
                            <div class="">
                                <div class="vx-row mb-2">
                                    <div class="vx-col sm:w-1/2 md:w-1/3">
                                        <p class="mb-1">Contratos</p>
                                        <vs-chip class="chip-black" :color="contractsStatus != 'Pendiente' ? '#BBFFAA' : '#FFF1E3'">{{ contractsStatus != 'Pendiente' ? 'Firmados' : 'Pendiente' }} &nbsp;</vs-chip>
                                    </div>
                                    <div class="vx-col sm:w-1/2 md:w-1/3">
                                        <p class="mb-1">Anexos</p>
                                        <vs-chip class="chip-black" :color="secondContractsStatus != 'Pendiente' ? '#BBFFAA' : '#FFF1E3'">{{ secondContractsStatus != 'Pendiente' ? 'Firmados' : 'Pendiente de generar' }} &nbsp;</vs-chip>
                                    </div>
                                    <div class="vx-col sm:w-1/2 md:w-1/3">
                                        <p class="mb-1">Factura</p>
                                        <vs-chip class="chip-black" :color="hasInvoices ? '#BBFFAA' : '#FFF1E3'">{{ hasInvoices ? 'Cargados' : 'Pendiente' }} &nbsp;</vs-chip>
                                    </div>
                                </div>
                                <div class="vx-row">
                                    <div class="vx-col sm:w-1/2 md:w-1/3 mb-2">
                                        <p @click.stop="sendContractsNotif(1)" class="text-sm bold clickable-img"><u>Enviar recordatorio</u></p>
                                    </div>
                                    <div class="vx-col sm:w-1/2 md:w-1/3 mb-2">
                                        <p @click.stop="goToPage(3)" class="text-sm bold clickable-img"><u>Ver detalles</u></p>
                                    </div>
                                    <div class="vx-col sm:w-1/2 md:w-1/3 mb-2">
                                        <p @click.stop="goToPage(2)" class="text-sm bold flex clickable-img">
                                            <feather-icon icon="UploadIcon" class="w-5 h-5 mr-2"></feather-icon>
                                            <u>Subir</u>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </vx-card>
                    </div>
                </div>
            </div>
            <!-- INSTALACIÓN -->
            <div v-if="steps[5] == 1" class="vx-col w-full">
                <div class="vx-row same-h">
                    <div class="vx-col sm:w-full md:w-1/2 mb-2">
                        <vx-card>
                            <h4 class="mb-base mt-4">¡Proyecto en instalación!</h4>
                            <p class="mb-4 black text-sm mb-base">
                                Recibiste el anticipo el <span class="bold">{{ midDateFormat(project.installation_date) }}</span>. Recuerda que tienes 30 días para concluir la instalación e iniciar trámite de interconexión. 
                                <br>
                                <br>
                                Recibirás el resto del crédito cuando firmes los anexos y compartas las evidencias. 
                            </p>
                        </vx-card>
                    </div>
                    <div class="vx-col sm:w-full md:w-1/2 mb-2">
                        <vx-card>
                            <h4 class="mb-base">¿Qué falta?</h4>
                            <div class="">
                                <div class="vx-row mb-2">
                                    <div class="vx-col sm:w-1/2 md:w-1/3">
                                        <p class="mb-1">Datos técnicos</p>
                                        <vs-chip class="chip-black" :color="fundData.serial_numbers != 'Incompletas' ? '#BBFFAA' : '#FFF1E3'">{{ fundData.serial_numbers != 'Incompletas' ? 'Cargados' : 'Pendiente' }} &nbsp;</vs-chip>
                                    </div>
                                    <div class="vx-col sm:w-1/2 md:w-1/3">
                                        <p class="mb-1">Evidencias</p>
                                        <vs-chip class="chip-black" :color="project.evidence_verification_request_date != null ? '#BBFFAA' : '#FFF1E3'">{{ project.evidence_verification_request_date == null ? 'Pendiente' : 'Cargados' }} &nbsp;</vs-chip>
                                    </div>
                                    <div class="vx-col sm:w-1/2 md:w-1/3">
                                        <p class="mb-1">Anexos</p>
                                        <vs-chip class="chip-black" :color="secondContractsStatus != 'Pendiente' ? '#BBFFAA' : '#FFF1E3'">{{ secondContractsStatus != 'Pendiente' ? 'Firmados' : 'Pendiente de generar' }} &nbsp;</vs-chip>
                                    </div>
                                </div>
                                <div class="vx-row">
                                    <div class="vx-col sm:w-1/2 md:w-1/3">
                                        <p @click.stop="goToPage(2)" class="text-sm bold flex clickable-img">
                                            <feather-icon icon="UploadIcon" class="w-5 h-5 mr-2"></feather-icon>
                                            <u>Subir</u>
                                        </p>
                                    </div>
                                    <div class="vx-col sm:w-1/2 md:w-1/3">
                                        <p @click.stop="goToPage(2)" class="text-sm bold flex clickable-img">
                                            <feather-icon icon="UploadIcon" class="w-5 h-5 mr-2"></feather-icon>
                                            <u>Subir</u>
                                        </p>
                                    </div>
                                    <div class="vx-col sm:w-1/2 md:w-1/3">
                                        <p @click.stop="goToPage(3)" class="text-sm bold flex clickable-img">
                                            <u>Firmar</u>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </vx-card>
                    </div>
                </div>
            </div>
            <!-- INSTALACIÓN -->
            <div v-if="steps[6] == 1" class="vx-col w-full">
                <div class="vx-row same-h">
                    <div class="vx-col w-full mb-2">
                        <vx-card>
                            <h4 class="mb-base mt-4">¡Proyecto entregado!</h4>
                            <p class="mb-4 black text-sm mb-base">
                                Gracias por ayudarnos a transformar al mundo un crédito a la vez. 
                                <br>
                                <br>
                                <span class="bold">Tu opinión es lo más importante.</span>
                            </p>
                            <vs-button @click="showFeedback" size="sm" color="#3B3A3E">
                                Califica tu experiencia
                            </vs-button>
                        </vx-card>
                    </div>
                </div>
            </div>
        </div>

        <div v-else>
            <vx-card v-if="isRejected" class="black">
                <h4 class="mb-4">Solicitud rechazada</h4>
                    <p class="bold mb-4">
                        {{ midDateFormat(project.rejected_date) }}
                    </p>
                    <p>
                        Lamentablemente no podemos aprobar el crédito de tu cliente. 
                        <br>Sugerimos que tu cliente intente nuevamente en un par de meses. 
                    </p>
            </vx-card>
            <vx-card v-else-if="isArchived" class="black">
                <h4 class="mb-4">Solicitud archivada</h4>
                <p class="mb-4">
                    <span class="bold">Archivado el: {{ midDateFormat(project.resolution_date) }}</span>
                    <template v-if="project.project_resolution.length > 0">
                        <br>
                        <span class="bold">Archivado por:</span>
                        {{  getResolutionActor(project.project_resolution[0].resolution) }}
                        <br>
                        <span class="bold">Razon de archivo:</span>
                        {{ project.project_resolution[0].resolution.category_name }}. {{ project.project_resolution[0].resolution.description }}
                    </template>
                </p>
                <div class="vx-col w-full flex mt-2" id="account-manage-buttons2" v-if="canUnarchiveProject">
                  <vs-button icon-pack="feather" icon="icon-archive" class="mr-4" @click="unarchiveProjectRequest()">
                    Desarchivar el proyecto </vs-button>
                </div>
            </vx-card>
        </div>

        <vs-popup v-if="isMounted" title="Oferta de crédito del solicitante" :active.sync="showOffer">
            <LoanOffer :onboardingStepData="project" :isMoral="isMoral" :isFromSupplier="true" />
        </vs-popup>
    </div>
</template>

<script>

import ProjectFundProgress from '@components/supplier/projects/ProjectFundProgress.vue'
import dateHelper from "@mixins/dateHelper";
import LoanOffer from '../../../views/applicant/loan-requests/components/shared_components/LoanOffer.vue';

export default {
    name: "LoanRequestStepDetail",
    mixins: [dateHelper],
    props: ["project", "technicalValidations"],
    data: () => ({
        isMounted: false,
        steps: [0, 0, 0, 0, 0, 0, 0, 0],
        pills: [
            { status: 0, name: "Solicitud" },
            { status: 1, name: "Revisión" },
            { status: 2, name: "Aprobado" },
            { status: 3, name: "Fondeo" },
            { status: 4, name: "Contratos" },
            { status: 6, name: "Entregado" }
        ],
        isCompleted: false,
        documentStatus: null,
        fundData: null,
        showOffer: false,
        activeTab: 0,
        guaranteeSelected: null,
        osUrl: "/obligado-solidario/onboarding/?t="
    }),
    components: {
        ProjectFundProgress,
        LoanOffer
    },
    mounted() {
        this.isMounted = false;
        this.showStepDetail();
        this.getDocumentStatus();
        if(this.isSFV) {
            this.loadPostFundData();
        }
        this.isMounted = true;
    },
    computed: {
        isMoral() {
            return this.client.user.person_type == 0 || this.client.user.person_type == 3;
        },
        isSFV() {
            return this.project.finance.loan_type == 1;
        },
        finance() {
            return this.project.finance;
        },
        client() {
            return this.project.client;
        },
        user() {
            return this.client.user;
        },
        personal() {
            return this.user.personal;
        },
        business() {
            return this.user.business;
        },
        hasPersonalGeneralDataCompleted()
        {
            if(this.isMoral) {
                return true;
            } else {
                return this.personal.address != null ? this.personal.address.neighborhood_id != null : false;
            }
        },
        hasPersonalOccupationDataCompleted()
        {
            if(this.isMoral) {
                return true;
            } else {
                return this.personal.personal_occupation_id != null
            }
        },
        hasCDCDataCompleted()
        {
            if(this.isMoral) {
                return this.business.last_credit_request != null
            } else {
                return this.personal.last_credit_request != null
            }
        },
        guaranteesList()
        {
            return this.project.finance.guarantees_list;
        },
        hasPersonalIdentityVerification()
        {
            if(this.isMoral) {
                return this.business.personal.identity_verification_dashboard_url != null;
            } else {
                return this.personal.identity_verification_dashboard_url != null;
            }
        },
        hasSyntage() {
            return this.business.has_valid_sat_profile;
        },
        applicantIsCompleted() {
            if(this.isMoral) {
                return this.accountIsActive && this.hasCDCDataCompleted && this.hasSyntage;
            }
            return this.accountIsActive && this.hasCDCDataCompleted && this.hasPersonalIdentityVerification;
        },
        contracts()
        {
            return this.project.contracts.filter(x => x.contract_group_id == 1 ||  x.contract_group_id == 2 );
        },
        hasContracts() {
            return this.contracts.length > 0 && this.contracts.filter(x => x.status == "generated" || x.status == "sent" || x.status == "signed" || x.status == "verified").length > 0;
        },
        contractsStatus()
        {
            let hasContracts = this.contracts.length > 0 && this.contracts.filter(x => x.status == "signed" || x.status == "verified").length > 0;

            return hasContracts ? 'Firmados' : 'Pendiente';
        },
        secondContractsStatus() {
            let hasContracts = this.project.contracts.filter(x => x.contract_group_id == 4 ||  x.contract_group_id == 3 );

            return hasContracts.length > 0 && hasContracts.filter(x => x.status == "signed" || x.status == "verified").length > 0 ? 'Firmados' : 'Pendiente';

        },
        contractAnnex()
        {
            return this.project.contracts.filter(x => x.contract_group_id == 4 ||  x.contract_group_id == 3 );
        },
        hasTechnicalData()
        {
            if(this.technicalValidations != null && this.technicalValidations.validations.length > 0) {
                return this.technicalValidations.validations[0].dataValidations.complete;
            } else {
                return false;
            }
        },
        hasInvoices()
        {
            return this.project.pdf_invoices.length > 0 && this.project.xml_invoices.length > 0;
        },
        isRejected()
        {
            return this.project.rejected_date != null;
        },
        isArchived()
        {
            return this.project.resolution_date != null;
        },
        // NUEVO FLUJO -- 
        accountIsActive() {
            return this.project.client.user.active == 1;
        },
        loanAccepted() {
            return this.project.finance.credit_acceptance_date != null;
        },
        getPreapprovedTitle() {
            let title = "Detalle de la presolicitud.";

            if(this.project.preapproved != null) {
                title = "¡Crédito pre-aprobado!";
            } else if(this.project.preapproved == null && this.project.loan_review_request_timestamp != null && this.applicantIsCompleted) {
                title = "Pre-solicitud en revisión";
            } else if(this.project.preapproved == null && this.project.loan_review_request_timestamp == null && !this.applicantIsCompleted) {
                title = "Pre-solicitud en proceso";
            } 
            return title;
        },
        getPreapprovedDescription() {
            let description = "Estamos revisando la información de tu cliente para realizar la pre-aprobación. <br> Puedes continuar con el llenado de la solicitud.";

            if(this.project.preapproved != null) {
                description = "El crédito de tu cliente fue pre-aprobado. <br> Continua con el llenado de la solicitud.";
            } else if(this.project.preapproved == null && this.project.loan_review_request_timestamp != null && this.applicantIsCompleted) {
                description = "Estamos analizando la información de tu cliente para  realizar la pre-aprobación. <br> Puedes continuar con el llenado de la solicitud.";
            } else if(this.project.preapproved == null && this.project.loan_review_request_timestamp == null && !this.applicantIsCompleted) {
                if(this.isMoral) {
                    description = "Es necesario que tu cliente complete su proceso para realizar la revisión y pre-aprobación. <br><br> Puedes continuar con el llenado de la solicitud.";
                } else {
                    description = "Es necesario que tu cliente complete su proceso e ingreses en su solicitud el acta constitutiva o última acta de asamblea de la empresa para realizar la revisión y pre-aprobación. <br><br> Puedes continuar con el llenado de la solicitud.";
                }
            }
            return description;
        },
        resolution_client_cause() {

            if(this.project.project_resolution.length == 0) {
                return 0;
            }

            const role = this.getResolutionActor(this.project.project_resolution[0].resolution);
            console.log("role", role);

            return role == "Instalador" ? 1 : 0;

        },
        canUnarchiveProject() {
            // Se pueden desarchivar solo los proyectos que archivo el proveedor
            return this.resolution_client_cause != 0 && this.isArchived;
        },
    },
    methods: {
        async sendContractsNotif(contract_group_id) {
            try {
                this.showLoading(true, "Enviando notificación...");
                await axios.post(`/api/project/${this.project.id}/re_send_contracts_mi_fiel/${contract_group_id}`);
                this.saveSuccessNotif(null, "Notificación de contratos enviada.");
                this.showLoading(false);
            } catch (error) {
                this.showLoading(false);
                console.error("Error sending contracts notification:", error);
                throw error;
            }
        },
        showFeedback(){
            this.$store.commit('TOGGLE_IS_FEEDBACK_POPUP_ACTIVE', true)
        },
        getIcon(icon) {
            const icons = {
                "01": "01_engine_icon.png"
                , "02": "02_document_icon.png"
                , "03": "03_user_icon.png"
                , "04": "04_search_clock_icon.png"
                , "05": "05_money_icon.png"
                , "06": "06_cpu_icon.png"
                , "07": "07_image_icon.png"
                , "08": "08_survey_icon.png"
                , "09": "09_loan_rejected.png"
            };

            return `https://cdn.redgirasol.com/suppliers/resources/icons/${icons[icon] || ""}`;
        },
        newGetDate(s) {
            let dd = null;
            switch (s) {
                case 0:
                    dd = this.project.created_at;
                    break;
                case 1:
                    dd = this.project.loan_review_request_timestamp;
                    break;
                case 2:
                    dd = this.project.loan_proposal_timestamp;
                    break;
                case 3:
                    dd = this.project.public_date;
                    break;
                case 4:
                    dd = this.project.contracts_created_at;
                    break;
                case 5:
                    dd = this.project.installation_date;
                    break;
                case 6:
                    dd = this.project.delivery_date;
                    break;
            }
            if (dd != null) {
                return dd;
            }
            else {
                return null;
            }
        },
        showStepDetail() {

            if(this.isSFV) {
                this.pills = [
                    { status: 0, name: "Solicitud" },
                    { status: 1, name: "Revisión" },
                    { status: 2, name: "Aprobado" },
                    { status: 3, name: "Fondeo" },
                    { status: 4, name: "Contratos" },
                    { status: 5, name: "Instalación" },
                    { status: 6, name: "Entregado" }
                ]
            }

            let isCompleted = 0;
            let aux = 1;

            for (let index = 0; index < this.pills.length; index++) {
                const element = this.pills[index];
                const newDate = this.newGetDate(element.status);

                // Sí es el último status = 7 no se suma nada
                if(element.status == 7) {
                    aux = 0;
                } else if(!this.isSFV && element.status == 7) { // Sí no es SFV y el status es 5, se suman 2 
                    aux = 2;
                } else { // a todos los demás, se sube 1.
                    aux = 1;
                }
                // Se consulta la siguiente fecha del collar para saber si el icono puede cambiar.
                let nextDate = this.newGetDate(element.status + aux);

                // Si la fecha actual es != null y la siguiente fecha es null, se prende el step
                console.log(`${element.status} - ${newDate}`);
                if( newDate != null && nextDate == null) {
                    this.steps[element.status] = 1;
                    break;
                } else {
                    this.steps[element.status] = 0;
                }

            }

            // console.log(this.pills.length, isCompleted);
            this.isCompleted = isCompleted == this.pills.length;
        },
        hasGuaranteeDataCorrect(step = 0) {
            const flags = [];

            switch (step) {
                case 0:
                    this.guaranteesList.forEach(os => {
                        if(os.is_guarantee == 1) {
                            if(os.guarantee_profile != null) {
                                const profile = os.guarantee_profile;
                                if(
                                    profile.rejected_date == null &&
                                    (profile.email != null && profile.email != "")
                                ) {
                                    flags.push(true);
                                }
                            }
                        }
                    });
                    break;

                    case 1: // DIRECCIÓN
                        this.guaranteesList.forEach(os => {
                            if(os.is_guarantee == 1) {
                                if(os.guarantee_profile != null) {
                                    const profile = os.guarantee_profile;
                                    const guaranteeIsMoral = profile.business_profile_id != null;
                                    const address = guaranteeIsMoral ? profile.business.address : profile.personal.address;
                                    if(
                                        address != null 
                                        && address.neighborhood_id != null
                                    ) {
                                        flags.push(true);
                                    }
                                }
                            }
                        });
                    break;
                    case 2: // CDC
                        this.guaranteesList.forEach(os => {
                            if(os.is_guarantee == 1) {
                                if(os.guarantee_profile != null) {
                                    const profile = os.guarantee_profile;
                                    const guaranteeIsMoral = profile.business_profile_id != null;
                                    const fiscal = guaranteeIsMoral ? profile.business : profile.personal;
                                    if(
                                        fiscal != null
                                        && fiscal.last_credit_request != null
                                    ) {
                                        flags.push(true);
                                    }
                                }
                            }
                        });
                    break;
                    case 3: // Verificación de identidad
                        this.guaranteesList.forEach(os => {
                            if(os.is_guarantee == 1) {
                                if(os.guarantee_profile != null) {
                                    const profile = os.guarantee_profile;
                                    const guaranteeIsMoral = profile.business_profile_id != null;
                                    const personal = guaranteeIsMoral ? profile.business.personal : profile.personal;
                                    if(
                                        personal != null
                                        && personal.identity_verification_dashboard_url != null
                                    ) {
                                        flags.push(true);
                                    }
                                }
                            }
                        });
                    break;
                default:
                    break;
            }

            return flags.length > 0;
        },
        hasGuaranteeData( step, guarantee ) {
            let flag = false;
            let gProfile = guarantee.guarantee_profile;
            switch(step) {
                case 0: // Domicilio
                    flag = guarantee.address != null && guarantee.address.neighborhood_id != null;
                break;
                case 1: // CDC
                    if(gProfile.business) {
                        flag = gProfile.business != null && gProfile.business.last_credit_request != null;
                    } else {
                        flag = gProfile.personal != null && gProfile.personal.last_credit_request != null;
                    }
                break;
                case 2: // Identity
                    if(gProfile.business) {
                        flag = gProfile.business.personal != null && gProfile.business.personal.identity_verification_dashboard_url != null;
                    } else {
                        flag = gProfile.personal != null && gProfile.personal.identity_verification_dashboard_url != null;
                    }
                break;
            }

            return flag;
        },
        requestNotificationToGuarantee(guarantee) {
            this.guaranteeSelected = guarantee;
            this.$vs.dialog({
                type: 'confirm',
                color: '#3B3A3E',
                title: 'Notificación',
                text: `Se enviará un recordatorio al obligado solidario de tu cliente para que concluya su proceso.`,
                acceptText: "Enviar",
                cancelText: 'Cancelar',
                accept: this.doSendGuaranteeReminder
            });
        },
        async doSendGuaranteeReminder()
        {
            try {
                this.showLoading(true);
                await axios.post(`/api/guarantee/post/${this.guaranteeSelected.guarantee_profile_id}/send-reminder/1`);
                this.saveSuccessNotif();
                
                this.showLoading(false);
            } catch (error) {
                this.showLoading(false);
                this.failedOperationNotif();
            } finally {
                this.showLoading(false);
            }
        },
        getContractsGroupStatus(isExtraDocuments = false)
        {
            try {
                const contracts = !isExtraDocuments ? this.contracts : this.contractAnnex;

                let status = {
                    color: "text-grey",
                    text: "Pendiente generar"
                };
            
                if(contracts != null) {
                    for (let index = 0; index < contracts.length; index++) {
                        const element = contracts[index];
                        element
                        if(element.status == "generated") {
                            status.text = "Pendiente de envío";
                            break;
                        } else if (element.status == "sent") {
                            status.text = "Contratos firmados";
                            break;
                        } else if (element.status == "signed" || element.status == "verified") {
                            status.text = "Contratos firmados";
                            status.color = "text-primary";
                        }
                    }
                }


                return status;

            } catch (error) {
                console.log("No se pudo calcular el estatus de los contratos.", error)
            }
        },
        /**
         *  requestTabIndex: 0,
         *  prefundTabIndex: 1,
         *  postfundTabIndex: 2,
         *  contractsTabIndex: 3,
         */
        goToPage(index)
        {
            this.$emit("goToPage", index);
        },
        showFeedback(){
            this.$store.commit('TOGGLE_IS_FEEDBACK_POPUP_ACTIVE', true)
        },
        async getDocumentStatus()
        {
            try {
                const res = await axios.get(`/api/document/get/status/${this.project.id}`);
                this.documentStatus = res.data.document_status;
            } catch (error) {
                return false;
            }
        },
        async loadPostFundData(){
            try {
                let res = await axios.get(`/api/loan/get/status/post-fund/${this.project.id}`);
                // let res = await axios.get(`/api/loan-onboarding/get/not-assigned-loans`);
                this.fundData = res.data;
            }
            catch (e) {
                this.warn(e);
            }
        },
        getSurveyStatus() 
        {
            let status = {
                color: "text-grey",
                text: "Pendiente"
            };

            if(this.project.applicant_feedback_request_date != null) {
                status.text = "Encuesta enviada";
            }

            if(this.project.applicant_feedback_date != null) {
                status.text = "Encuesta completada";
                status.color = "text-primary";
            }

            return status;
        },
        getName(profile) {
            if(profile.business != null) {
                return profile.business.name;
            } else {
                const personal = profile.personal;
                return `${personal.first_name} ${personal.last_name_1}`;
            }
        }, 
        copyClipboard(type, profile = null)
        {
            let textToCopy = "";
            switch (type) {
                case 'os-url':
                    textToCopy =  this.AppDomain + this.osUrl + profile.guarantee_profile.auth_token;
                    break;
                case 'applicant':
                    textToCopy = this.AppDomain + `/solicitante/${this.project.id}/activa-tu-cuenta/${this.user.preauth}`;
                    break;
                case 'loan_offer':
                    textToCopy = this.AppDomain + `/solicitante/solicitud-de-credito/${this.project.id}`;
                    break;
                default:
                    textToCopy = this.project.id;
            }
            navigator.clipboard.writeText(textToCopy);
            this.saveSuccessNotif(null, "Texto copiado al portapapeles.");
        },
        async requestApplicantNotification( type )
        {
            try {
                await axios.post(`/api/loan/post/applicant-onboarding/notification`, {
                    project_id: this.project.id,
                    user_id: this.user.id,
                    case: type
                });

                this.saveSuccessNotif(null, "Notificación enviada al solicitante.");
            } catch (error) {
                this.warn(error);
            }
        },
        getResolutionActor(resolution) {
            if(resolution != null) {
                if(resolution.resolution_actor == 'redgirasol') {
                    return "RedGirasol";
                } else if(resolution.resolution_actor == 'supplier') {
                    return "Instalador";
                } else if(resolution.resolution_actor == 'applicant') {
                    return "Solicitante";
                } else {
                    return "Desconocido";
                }
            } else {
                return "Desconocido";
            }
        },
         unarchiveProjectRequest() {
            let proj = this.project;
            let mssg = "¿Realmente desea desarchivar el proyecto " + proj.id + "?";

            if (proj.step != 4) {
                mssg += " El proyecto se desarchivará con el estado que tenía.";
            }
            else {
                // RNs 
                // si tenia menos de 30 dias aprobado, se desarchiva como aprobado,
                // si tenia mas de 30 dias aprobado, se desarchiva como pre-aprobado
                if (proj.approved_days <= 30) {
                mssg += " El proyecto se desarchivará en estado aprobado.";
                }
                else {
                mssg += " El proyecto tenía más de 30 días de aprobado, por lo que se desarchivará pero volverá a estado pre-aprobado.";
                }
            }

            this.$vs.dialog({
                type: 'confirm',
                color: 'danger',
                title: 'Desarchivar proyecto',
                text: mssg,
                acceptText: "Desarchivar",
                cancelText: 'Cancelar',
                accept: this.doUnarchiveProject
            });
            },
        async doUnarchiveProject() {
            this.loading = true;
            let obj = { project: this.project.id };
            try {
                await axios.post('/api/v1/supplier/unarchiveProject', obj);
                this.$router.go();
            }
            catch (error) {
                this.$vs.notify({
                color: 'danger',
                title: 'Error',
                text: 'Ha ocurrido un error en la operación, intente más tarde'
                });
            }
            this.loading = false
        },
    }
}
</script>

<style>

.chip-black {
    padding: .5rem;
    color: black !important;
}
.text-start {
    text-align: start;
}

.align-lists {
    left: -2rem;
    position: relative;
    margin-bottom: 0;
}

.img-center {
    text-align: -webkit-center;
}
</style>